const ProjectServicesList = () => import('Views/projectServices/projectServices-list');
const ProjectServicesDetail = () => import('Views/projectServices/projectServices-detail-new-ui');

export default[
  { path: '/projectServices-list', component: ProjectServicesList },
  { path: '/projectServices-detail/:id', component: ProjectServicesDetail },
];



// WEBPACK FOOTER //
// ./src/router/projectServices.js